import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { LayoutService } from 'src/app/_core/services/layout.service';
import { tap } from 'rxjs/operators';
import { SubscriptionManager } from 'src/app/_core/tools/subscription-manager';

@Directive({
    selector: '[appIsMobile]',
    standalone: false
})
export class IsMobileDirective extends SubscriptionManager implements OnInit {

    private hasView = false;

    private condition = true; // display if mobile

    constructor(private readonly layoutService: LayoutService,
                private readonly templateRef: TemplateRef<any>,
                private readonly vcr: ViewContainerRef) {
        super();
    }

    @Input()
    set appIsMobile(condition: boolean) {
        this.condition = condition;
    }

    ngOnInit(): void {
        this.layoutService.isMobile$.pipe(
            this.untilDestroyed,
            tap((isMobile: boolean) => {
                if (isMobile === this.condition && !this.hasView) {
                    this.vcr.createEmbeddedView(this.templateRef);
                    this.hasView = true;
                } else if (this.hasView) {
                    this.vcr.clear();
                    this.hasView = false;
                }
            })
        ).subscribe();
    }

}
